import Box from "@mui/material/Box";
import jwt_decode from "jwt-decode";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useAnalyticsEventTracker from "../ga/googleAnalytics";

export const Login = ({ user, setUser }) => {
  const history = useHistory();
  const gaEventTracker = useAnalyticsEventTracker('HomePage');

  const handleCallbackResponse = async (response) => {

    const res = await fetch('/algo-trading/api/login/oauth2/social/google', { headers: { Authorization: 'Bearer ' + response.credential } })
    const jwt = await res.text()
    const algoJwt = jwt_decode(jwt)

    const userObject = jwt_decode(response.credential)
    userObject.role = algoJwt?.role
    userObject.credential = 'Bearer ' + jwt // TODO: Fix the header sending process by implementing custom fetch
    userObject.exp = algoJwt?.exp
    localStorage.setItem('user', JSON.stringify(userObject));
    setUser(userObject)
    const signInDiv = document.getElementById("signInDiv")
    if (signInDiv)
      signInDiv.hidden = true
    saveUserLogin(userObject)
    gaEventTracker('login')
    history.push('/dashboard')
  }

  const saveUserLogin = userObject => {
    if (!userObject) return;

    const requestBody = {
      'name': userObject.name || '',
      'email': userObject.email || ''
    }

    fetch('/algo-trading/api/login-track', {
      headers: { 'Content-Type': 'application/json', 'Authorization': userObject?.credential },
      method: 'POST',
      body: JSON.stringify(requestBody)
    })
  }

  useEffect(() => {
    /* global google */
    if (google !== undefined) {
      google.accounts.id.initialize({
        client_id: "7877754101-s2o2vdeunbbbf2gg9uto3tvnpaij2u0q.apps.googleusercontent.com",
        callback: handleCallbackResponse
      });

      google.accounts.id.renderButton(
        document.getElementById("signInDiv"),
        { theme: "outline", size: "large" }
      );
    }
  }, [])

  if (Object.keys(user)?.length > 0) return null

  return (
    <Box component="form" noValidate sx={{ mt: 1 }}>
      <div id="signInDiv" />
    </Box>
  )
}